import { http, createConfig } from 'wagmi'
import { sepolia, mainnet } from 'wagmi/chains'
import { getEnv } from './env'

const { mainnetRpcUrl, sepoliaRpcUrl, demoPrivateKey } = getEnv()

export const wagmiConfig = demoPrivateKey
  ? createConfig({
      chains: [sepolia],
      transports: {
        [sepolia.id]: http(sepoliaRpcUrl || sepolia.rpcUrls.default.http[0]),
      },
    })
  : createConfig({
      chains: [mainnet, sepolia],
      transports: {
        [mainnet.id]: http(mainnetRpcUrl || mainnet.rpcUrls.default.http[0]),
        [sepolia.id]: http(sepoliaRpcUrl || sepolia.rpcUrls.default.http[0]),
      },
    })
